<template>
  <div class="pdf-content-body" ref="pdfContentBody">
    <div class="row" v-if="pdf !== null">
      <pdf-doc :pdf="pdf" :selectedPdf="selectedPdf" :id="pdfId"></pdf-doc>
      <pdf-extraction :key="selectedPdf" :pdfId="pdfId"></pdf-extraction>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { getPdfIndexById } from "@/data/getters";
import PdfDoc from "@/components/includes/pdf/PdfDoc";
import PdfExtraction from "@/components/includes/pdf/PdfExtraction";
import EventBus from "../../../event-bus";
import { PDF_FILE_TYPE } from "@/config";
import { h } from "vue";

export default {
  name: "pdf-content-body",
  data() {
    return {
      pdf: null,
      // Which fetch is the current one; see loadPdf.
      loadToken: 0,
    };
  },
  components: {
    "pdf-doc": PdfDoc,
    "pdf-extraction": PdfExtraction,
  },
  props: {
    selectedPdf: {
      type: Number,
      required: true,
    },
  },
  computed: {
    pdfId() {
      const pdfs = this.allData?.pdfs;
      if (!pdfs || !pdfs[this.selectedPdf]) return null;
      return pdfs[this.selectedPdf].id;
    },
    ...mapGetters("login", {
      allData: "getAllData",
    }),
  },
  beforeDestroy() {
    // clean up
    this.loadToken += 1;
    this.pdf = null;
    delete this.pdf;
  },
  methods: {
    ...mapActions("login/pdf", ["requestPdfById"]),
    // The bytes on screen must always be pdfId's: the viewer's grabs, the
    // report draft and the report save are filed against pdfId. The list under
    // pdfId changes while a fetch is under way (a chart switch, a re-read after
    // an upload, the dropdown), and fetches answer in any order. So the previous
    // document is taken off screen as soon as the id changes, and an answer, or
    // a failure, for an id that is no longer selected is dropped. Without this
    // a slow fetch landing last put one PDF — even another patient's — in the
    // viewer under a different pdfId.
    loadPdf() {
      this.loadToken += 1;
      const token = this.loadToken;
      const id = this.pdfId;
      this.pdf = null;
      if (id == null) return;
      const current = () => token === this.loadToken && id === this.pdfId;
      let loader = this.$loading.show(
        {},
        {
          after: () => h("div", {}, "Transfering data to pdf viewer..."),
        }
      );
      this.requestPdfById(id)
        .then((pdf) => {
          if (current()) this.pdf = pdf;
        })
        .catch((err) => {
          if (!current()) return;
          console.error(err);
          this.$swal({
            type: "error",
            title: `Unable to retrieve`,
            text: `Unable to retrieve PDF. Please try again or choose another file.`,
          });
        })
        .finally(() => {
          loader.hide();
          loader = null;
        });
    },
  },
  created() {
    // console.dir(this);
    this.loadPdf();
  },
  watch: {
    // Dropdown selection changes the `selectedPdf` prop (and therefore the
    // computed `pdfId`) without re-mounting this component, so `created()`
    // does not re-fire. Without this watcher the iframe keeps showing the
    // first-loaded PDF on every subsequent dropdown change.
    pdfId(newId, oldId) {
      if (newId !== oldId) this.loadPdf();
    },
  },
};
</script>

<style scoped lang="scss"></style>
